import Token from '@/utils/Token';

export default {
    minhas(params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/notificacao/minhas${params}`, Token.getHeader());
    },
    naoLidasCount() {
        return axios.get(`/api/notificacao/nao-lidas-count`, Token.getHeader());
    },
    marcarLida(id) {
        return axios.post(`/api/notificacao/${id}/marcar-lida`, {}, Token.getHeader());
    },
    marcarTodasLidas() {
        return axios.post(`/api/notificacao/marcar-todas-lidas`, {}, Token.getHeader());
    },
};
